import { AccessibleFacility } from 'app/redux/profile/user/slice';

type FacilityWithProjects = { facility: AccessibleFacility; projects: AccessibleFacility[] };

export function orderAccessibleFacilities(facilities: AccessibleFacility[]) {
  return facilities
    .flatMap(groupProjectsUnderSourceFacility)
    .sort(sortFacilitiesAlphabetically)
    .flatMap(flattenIntoOneList);
}

function groupProjectsUnderSourceFacility(
  facility: AccessibleFacility,
  _: number,
  facilities: Array<AccessibleFacility>
) {
  if (facility.isVirtual) return [];
  const projects = facilities.filter(project => project.sourceFacilityGuid === facility.id).sort(sortByName);
  return [{ facility, projects }];
}

function sortByName(a: AccessibleFacility, b: AccessibleFacility) {
  return a.name.localeCompare(b.name);
}

function sortFacilitiesAlphabetically(a: FacilityWithProjects, b: FacilityWithProjects) {
  return sortByName(a.facility, b.facility);
}

function flattenIntoOneList({ facility, projects }: FacilityWithProjects) {
  return [facility, ...projects];
}
